var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.5L3.41483 3.56814C3.46062 3.5315 3.52797 3.54196 3.5605 3.59075L5.37813 6.31719C5.42573 6.38859 5.53523 6.37082 5.55781 6.28803L6.92614 1.2708C6.95089 1.18008 7.07581 1.17057 7.114 1.2565L8.9575 5.40437C8.98065 5.45647 9.04261 5.4787 9.0936 5.4532L10.9481 4.52595C10.9802 4.5099 11.0184 4.51228 11.0483 4.53219L12.5 5.5",
    stroke: "#50514E",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat);
export default __webpack_public_path__ + "static/media/stat.b00c8087c6092f97e70b5069baf611f7.svg";
export { ForwardRef as ReactComponent };